import * as yup from 'yup';

export const quoteCommentsInitialValues = {
  quoteComments: '',
};

export const validationSchema = yup.object().shape({
  quoteComments: yup.string().required('Quote comments are required'),
});
